import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import MessageQuill from "../Message/MessageQuill";
import { BtnPrimary } from "../../share/buttons/Btn";

function TeamModal({ close }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log("data", data);
  return (
    <div className="AddnewsupportTicket relative ">
      {" "}
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
        ثبت گروه جدید
      </h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="نام گروه*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Email",
            },
          }}
          type="email"
          name="email"
          control={control}
          placeholder="افراد گروه*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Email",
            },
          }}
          type="text"
          name="title"
          control={control}
          placeholder="نام ایده*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <MessageQuill placeholder="شرح ایده *" />
        <BtnPrimary
          className="py-[20px] px-[25px] flex mr-auto "
          text="ثبت گروه"
        />
      </form>
    </div>
  );
}

export default TeamModal;
